import type { QueryParams } from '#reducers/router';
import type { CodeRefsFilter } from '#utils/codeRefs/types';
import { CodeReferencesFilterKind } from '#utils/codeRefs/types';

import { createCodeReferenceFilters } from './records/CodeReferenceFilters';

export function createCodeReferenceFiltersFromQuery(query: QueryParams<keyof CodeRefsFilter>) {
  const repo = query?.get(CodeReferencesFilterKind.REPO);
  const branch = query?.get(CodeReferencesFilterKind.BRANCH);
  let extensions = query?.get(CodeReferencesFilterKind.EXTENSIONS, []);
  extensions = typeof extensions === 'string' ? [extensions] : extensions;
  const showEmpty = !!query?.get(CodeReferencesFilterKind.SHOW_EMPTY);

  return createCodeReferenceFilters({
    repo,
    branch,
    extensions,
    showEmpty,
  });
}
